import { render, staticRenderFns } from "./PayerScoreReportPreview.vue?vue&type=template&id=13f2d180&scoped=true"
import script from "./PayerScoreReportPreview.vue?vue&type=script&lang=js"
export * from "./PayerScoreReportPreview.vue?vue&type=script&lang=js"
import style0 from "./PayerScoreReportPreview.vue?vue&type=style&index=0&id=13f2d180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f2d180",
  null
  
)

export default component.exports